<h1 mat-dialog-title>{{ data.action }}</h1>
<div mat-dialog-content>
  <p *ngIf="data.message; else defaultMessage">{{ data.message }}</p>
  <ng-template #defaultMessage>
    <p>
      {{ "COMMON.CONFIRM" | translate }} {{ data.action }}
      {{ data.deleteContext }}?
    </p>
  </ng-template>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>
    {{ "COMMON.CANCEL" | translate }}
  </button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ delete: true }">
    {{ "COMMON.CONFIRM" | translate }}
  </button>
</mat-dialog-actions>
